import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import SunsetBlvd3600 from "../pages/ProductPages/3600WSunsetBlvd";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import UserProfile from "pages/Authentication/user-profile";
import UserManagement from "pages/UserManagement";
import Reports from "pages/Reports";
import Locations from "pages/Locations";
import Reserve from "pages/Reserve";
import LocationDetails from "pages/Locations/LocationDetails";
import MonthlyParking from "pages/MonthlyParking";
import Events from "pages/Events";
import LicencePlateCheck from "pages/ProductPages/LicencePlateCheck";
import DeveloperTickets from "pages/DeveloperTickets";
import Onboarding from "pages/Authentication/Onboarding";
import SLaBrea629 from "pages/ProductPages/629SLaBrea";
import OnboardingDriverLicense from "pages/Authentication/onboarding-steps/OnboardingDriverLicense";
import Performance from "pages/Performance";
import LoginActivity from "pages/LoginActivity";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/events", component: <Events /> },
  { path: "/locations", component: <Locations /> },
  { path: "/locations/:lot_id", component: <LocationDetails /> },
  { path: "/reserve", component: <Reserve /> },
  { path: "/reports", component: <Reports /> },
  { path: "/performance", component: <Performance /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/monthly-parking", component: <MonthlyParking /> },
  { path: "/user-management", component: <UserManagement /> },
  { path: "/login-activity", component: <LoginActivity /> },
  { path: "/developer-tickets", component: <DeveloperTickets /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name

  {
    path: "/",
    exact: true,
    component: <Navigate to="/locations" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/onboarding/:token", component: <Onboarding /> },
  { path: "/onboarding/driver-license/:token", component: <OnboardingDriverLicense /> },
  { path: "/3600-w-sunset-blvd", component: <SunsetBlvd3600 /> },
  { path: "/629-s-la-brea", component: <SLaBrea629 /> },
  { path: "/licence-plate-check", component: <LicencePlateCheck /> },
];

export { authProtectedRoutes, publicRoutes };
